import React, { useState } from "react";
import { Link } from "react-router-dom";

export default function Dashboard() {
  const [showConfirm, setShowConfirm] = useState(false);

  const handleDelete = () => {
    setShowConfirm(true);
  };

  const confirmDelete = () => {
    setShowConfirm(false);
    alert("Deleted successfully!");
  };

  return (
    <div style={{ padding: "30px" }}>
      <h1>Dashboard</h1>

      <Link to="/themes">
        <button
          style={{
            padding: "10px 20px",
            background: "#6C63FF",
            color: "white",
            border: "none",
            borderRadius: "6px",
          }}
        >
          View Themes
        </button>
      </Link>

      <button
        onClick={handleDelete}
        style={{
          marginLeft: "20px",
          padding: "10px 20px",
          background: "#FF6584",
          color: "white",
          border: "none",
          borderRadius: "6px",
        }}
      >
        Delete Something
      </button>

      {/* Custom Confirmation Modal */}
      {showConfirm && (
        <div
          style={{
            marginTop: "20px",
            padding: "20px",
            borderRadius: "10px",
            background: "#ffe6e6",
          }}
        >
          <p>Are you sure?</p>
          <button
            onClick={confirmDelete}
            style={{
              padding: "10px",
              background: "#FF6584",
              color: "white",
              marginRight: "20px",
              border: "none",
              borderRadius: "6px",
            }}
          >
            Yes
          </button>
          <button
            onClick={() => setShowConfirm(false)}
            style={{
              padding: "10px",
              background: "#ccc",
              border: "none",
              borderRadius: "6px",
            }}
          >
            No
          </button>
        </div>
      )}
    </div>
  );
}
